import { render, staticRenderFns } from "./RejectedTable.vue?vue&type=template&id=22d167fe"
import script from "./RejectedTable.vue?vue&type=script&lang=js"
export * from "./RejectedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports